export enum EConnectionCheckErrors {
  BAD_CREDS = 10,
  REQEST_ERROR = 20,
}
